type FirstUseCTAContainerProps = {
    children: React.ReactNode;
    className?: string;
};

export function FirstUseCTAContainer({ children, className = '' }: FirstUseCTAContainerProps) {
    return (
        <div
            className={
                className +
                ' flex flex-col items-center gap-4 rounded-lg border border-dashed border-gray-300 p-6 text-gray-600'
            }
        >
            {children}
        </div>
    );
}
